const GMAP_DRAWING_MODE = {
    NONE: 'NONE',
    CIRCLE: 'CIRCLE',
    POLYGON: 'POLYGON',
    INFO: 'INFO',
};

export { GMAP_DRAWING_MODE };